import {
	GET_ALL_MACHINE_IDS,
	GET_DEVICE_HEALTH_STATUS,
	GET_DEVICE_METRICS,
} from 'GraphQL/queries/contentService';
import {
	GET_ENTITIES_BY_TIME_RANGE,
	GET_TEMPORAL_PLACES_BY_REFERENCES,
} from 'GraphQL/queries/mapService';
import { TOTAL_SECONDS_IN_A_DAY } from 'utils/constants';

import { getTimeStamp } from 'utils/helpers';
export const getEntitiesByTimeRange = async ({
	entityType,
	machineInput,
	startDate,
	endDate,
	apolloClient,
}: {
	entityType: string;
	machineInput: any;
	startDate: any;
	endDate: any;
	apolloClient: any;
}) => {
	const response: any = await apolloClient.query({
		query: GET_ENTITIES_BY_TIME_RANGE,
		fetchPolicy: 'network-only',
		variables: {
			input: {
				entityIdStr: machineInput,
				entityType,
				timeRange: {
					startTime: {
						seconds: getTimeStamp(startDate) / 1000,
					},
					endTime: {
						seconds:
							getTimeStamp(endDate) / 1000 +
							(TOTAL_SECONDS_IN_A_DAY - 1),
					},
				},
			},
		},
	});
	return response;
};
export const executeFetchGeometry = async ({
	environment,
	machineInput,
	startDate,
	endDate,
	apolloClient,
}: {
	environment: any;
	machineInput: any;
	startDate: any;
	endDate: any;
	apolloClient: any;
}) => {
	const response: any = await apolloClient.query({
		query: GET_TEMPORAL_PLACES_BY_REFERENCES,
		fetchPolicy: 'network-only',
		variables: {
			input: {
				environment: { ...environment },
				timeRange: {
					startTime: {
						seconds: getTimeStamp(startDate) / 1000,
					},
					endTime: {
						seconds:
							getTimeStamp(endDate) / 1000 +
							(TOTAL_SECONDS_IN_A_DAY - 1),
					},
				},
				attributes: [
					{
						referenceType: 'MACHINE_REF_TYPE',
						attributes: [
							{
								key: 'MACHINE_ID',
								value: {
									valueType: 'VALUE_TYPE_STRING',
									stringValue: machineInput,
								},
							},
						],
					},
				],
			},
		},
	});
	return response;
};

export const executeFetchDeviceHealth = async ({
	machineInput,
	startDate,
	endDate,
	apolloClient,
}: {
	machineInput: any;
	startDate: any;
	endDate: any;
	apolloClient: any;
}) => {
	const response: any = await apolloClient.query({
		query: GET_DEVICE_HEALTH_STATUS,
		fetchPolicy: 'network-only',
		variables: {
			input: {
				timeRange: {
					startTime: {
						seconds: getTimeStamp(startDate) / 1000,
					},
					endTime: {
						seconds: getTimeStamp(endDate) / 1000,
					},
				},
				machineNo: machineInput,
			},
		},
	});
	return response;
};

export const executeFetchAllMachineIds = async ({
	apolloClient,
}: {
	apolloClient: any;
}) => {
	const response: any = await apolloClient.query({
		query: GET_ALL_MACHINE_IDS,
		fetchPolicy: 'network-only',
		variables: {
			input: {},
		},
	});
	return response;
};

export const executeFetchDeviceMetrics = async ({
	machineNumber,
	startTime,
	duration,
	apolloClient,
}: {
	machineNumber: any;
	startTime: any;
	duration: any;
	apolloClient: any;
}) => {
	const response: any = await apolloClient.query({
		query: GET_DEVICE_METRICS,
		fetchPolicy: 'network-only',
		variables: {
			input: {
				machineNumber: machineNumber,
				timeSlot: {
					startTime: {
						seconds: startTime,
					},
					duration: {
						seconds: duration,
					},
				},
			},
		},
	});
	return response;
};
